import { render, staticRenderFns } from "./ApplicationsListTable.vue?vue&type=template&id=0bb2a7df&"
import script from "./ApplicationsListTable.vue?vue&type=script&lang=js&"
export * from "./ApplicationsListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports